var _path, _g, _path2, _path3, _path4, _path5, _circle, _circle2, _path6, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcActionSkyMapDownload({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 6C2 4.89543 2.89543 4 4 4H20C21.1046 4 22 4.89543 22 6V18C22 19.1046 21.1046 20 20 20H4C2.89543 20 2 19.1046 2 18V6Z",
    fill: "url(#paint0_linear_2828_1770)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 9C13.7783 9 15.4376 9.35851 16.6895 9.98438C17.8815 10.5804 19 11.5887 19 13C19 14.4113 17.8815 15.4196 16.6895 16.0156C15.4376 16.6415 13.7783 17 12 17C10.2217 17 8.56242 16.6415 7.31055 16.0156C6.11846 15.4196 5 14.4113 5 13C5 11.5887 6.11846 10.5804 7.31055 9.98438C8.56242 9.35851 10.2217 9 12 9ZM12 10C8.68629 10 6 11.3431 6 13C6 14.6569 8.68629 16 12 16C15.3137 16 18 14.6569 18 13C18 11.3431 15.3137 10 12 10Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 6C14.9115 6 17.5962 6.70555 19.5859 7.89941C20.5544 8.4805 21.3948 9.20508 22 10.0459V15.9531C21.3948 16.7942 20.5546 17.5194 19.5859 18.1006C17.5962 19.2944 14.9115 20 12 20C9.0885 20 6.40383 19.2944 4.41406 18.1006C3.44536 17.5194 2.60523 16.7942 2 15.9531V10.0459C2.6052 9.20508 3.44561 8.4805 4.41406 7.89941C6.40383 6.70555 9.0885 6 12 6ZM12 7C6.47715 7 2 9.68629 2 13C2 16.3137 6.47715 19 12 19C17.5228 19 22 16.3137 22 13C22 9.68629 17.5228 7 12 7Z",
    fill: "white"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8 15C8 15.5523 7.55228 16 7 16C6.44772 16 6 15.5523 6 15C6 14.4477 6.44772 14 7 14C7.55228 14 8 14.4477 8 15Z",
    fill: "url(#paint1_linear_2828_1770)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5 12C19.5 12.5523 19.0523 13 18.5 13C17.9477 13 17.5 12.5523 17.5 12C17.5 11.4477 17.9477 11 18.5 11C19.0523 11 19.5 11.4477 19.5 12Z",
    fill: "url(#paint2_linear_2828_1770)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17 7C17 7.55228 16.5523 8 16 8C15.4477 8 15 7.55228 15 7C15 6.44772 15.4477 6 16 6C16.5523 6 17 6.44772 17 7Z",
    fill: "url(#paint3_linear_2828_1770)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M8 7.5C8 8.05228 7.55228 8.5 7 8.5C6.44772 8.5 6 8.05228 6 7.5C6 6.94772 6.44772 6.5 7 6.5C7.55228 6.5 8 6.94772 8 7.5Z",
    fill: "url(#paint4_linear_2828_1770)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 3,
    fill: "url(#paint5_linear_2828_1770)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 19,
    cy: 19,
    r: 5,
    transform: "rotate(-180 19 19)",
    fill: "url(#paint6_linear_2828_1770)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M19 21.8994L16 19L18 19V17L20 17V19L22 19L19 21.8994Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2828_1770",
    x1: 12,
    y1: 4,
    x2: 12,
    y2: 20,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.399675,
    stopColor: "#25282D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5042EB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2828_1770",
    x1: 6,
    y1: 14,
    x2: 8,
    y2: 16,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.111249,
    stopColor: "#FCFBFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.706731,
    stopColor: "#BDCEDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.879808,
    stopColor: "#DDE5EB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2828_1770",
    x1: 17.5,
    y1: 11,
    x2: 19.5,
    y2: 13,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.111249,
    stopColor: "#FCFBFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.706731,
    stopColor: "#BDCEDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.879808,
    stopColor: "#DDE5EB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2828_1770",
    x1: 15.5,
    y1: 6,
    x2: 17,
    y2: 8,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.111249,
    stopColor: "#FCFBFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.492188,
    stopColor: "#BDCEDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.879808,
    stopColor: "#DDE5EB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_2828_1770",
    x1: 3.5,
    y1: 8,
    x2: 5.5,
    y2: 10,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.111249,
    stopColor: "#FCFBFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.706731,
    stopColor: "#BDCEDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.879808,
    stopColor: "#DDE5EB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_2828_1770",
    x1: 10,
    y1: 10,
    x2: 15,
    y2: 15,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3FF5A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.682692,
    stopColor: "#F99C1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.875,
    stopColor: "#F7D750"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_2828_1770",
    x1: 19,
    y1: 24,
    x2: 19,
    y2: 14,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#16C866"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#14B35B"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcActionSkyMapDownload);
export default __webpack_public_path__ + "static/media/ic_action_sky_map_download.269df7f4546efbb4557be7d1c76750de.svg";
export { ForwardRef as ReactComponent };